<template>
  <b-modal
    id="select-folder-modal"
    title="Select Folder"
    size="lg"
    ok-only
    :ok-disabled="!selectedItems.length"
    @ok="handleOkClick"
  >
    <FolderContentView
      :is-only-folder="true"
      :can-create-folder="mode === 'selectAndCreate'"
      :multiple-selection="mode !== 'selectAndCreate'"
      @onSelectedItems="(items) => selectedItems = items"
    />
  </b-modal>
</template>
<script>
import { FILE_TYPE } from '../../../../constants/file-image-types';
import FolderContentView from '../FolderContentView.vue';
export default {
  components: { FolderContentView },
  props: {
    mode: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      selectedItems: []
    }
  },
  methods: {
    async handleOkClick() {
      let allFilesToAdd = [];

      for (const item of this.selectedItems) {
        if (item.type === FILE_TYPE.FOLDER) {
          const folderFiles = await this.getDirectFilesFromFolder(item.id);
          allFilesToAdd = [...allFilesToAdd, ...folderFiles];
        } else {
          allFilesToAdd.push(item);
        }
      }

      this.$emit('onSelectedItems', allFilesToAdd);
    },

    async getDirectFilesFromFolder(folderId, pageNumber = 1, allFiles = []) {
      try {
        const response = await axios.get('/file/folder_content', {
          params: {
            folderId: folderId,
            searchKey: '',
            pageNumber: pageNumber,
            pageSize: 100,
            folder_id: 0
          }
        });

        const data = response.data;
        const items = data.items || [];

        for (const item of items) {
          if (item.id === null && item.is_root === true) {
            continue;
          }

          if (item.type !== FILE_TYPE.FOLDER && item.type !== FILE_TYPE.PSD) {
            allFiles.push(item);
          }
        }

        if (data.current_page < data.last_page) {
          return await this.getDirectFilesFromFolder(folderId, pageNumber + 1, allFiles);
        }

        return allFiles;
      } catch (error) {
        console.error('Error fetching folder contents:', error);
        toastr.error('Failed to fetch folder contents');
        return allFiles;
      }
    }
  }
}
</script>